import { Mic, Keyboard } from 'lucide-react';
import { motion } from 'framer-motion';

interface InputModeToggleProps {
  mode: 'voice' | 'text';
  onModeChange: (mode: 'voice' | 'text') => void;
  disabled: boolean;
}

const OPTIONS: Array<{
  value: 'voice' | 'text';
  label: string;
  Icon: typeof Mic;
}> = [
  { value: 'voice', label: 'Voice', Icon: Mic },
  { value: 'text', label: 'Text', Icon: Keyboard },
];

export default function InputModeToggle({
  mode,
  onModeChange,
  disabled,
}: InputModeToggleProps) {
  return (
    <div
      role="tablist"
      aria-label="Answer input mode"
      className="inline-flex items-stretch self-center gap-0 border-b border-border/70"
    >
      {OPTIONS.map(({ value, label, Icon }, idx) => {
        const active = mode === value;
        return (
          <button
            key={value}
            role="tab"
            aria-selected={active}
            type="button"
            onClick={() => onModeChange(value)}
            disabled={disabled}
            className={`relative inline-flex items-center gap-2 px-6 py-3 font-sans text-sm transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${
              idx > 0 ? 'border-l border-border/70' : ''
            } ${
              active
                ? 'text-primary font-semibold'
                : 'text-text-muted hover:text-text-secondary font-medium'
            }`}
          >
            <Icon size={15} />
            <span>{label}</span>
            {active && (
              <motion.span
                layoutId="input-mode-underline"
                className="absolute -bottom-[1px] left-3 right-3 h-[2px] bg-primary rounded-full"
                transition={{ type: 'spring', stiffness: 380, damping: 30 }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
